/* ----------------- React Native Paper --------------- */
import { Card } from "react-native-paper";

import { Pressable } from "react-native";
/* ----------------- Components --------------- */
import {
	MasteryListItem,
	type MasteryListItemProps,
} from "../../MasteryListItem";

type Props = {
	items: MasteryListItemProps[];
	tagType?: string;
	handleClickCard?: () => void;
};

export type { MasteryListItemProps };

const getToolTip = (item: MasteryListItemProps, tagType?: string) => {
	const { low, high, medium, none } = item.distribution;

	const masteryParts = [
		high > 0 && `mastered ${high}`,
		medium > 0 && `are proficient in ${medium}`,
		low > 0 && `are familiar with ${low}`,
		none > 0 && `have not yet studied ${none}`,
	].filter(Boolean);

	const masteryText =
		masteryParts.length > 0
			? `. You ${
					masteryParts.length > 1
						? `${masteryParts.slice(0, -1).join(", ")} and ${masteryParts.slice(-1)}`
						: masteryParts[0]
				}`
			: "";

	return `You answered ${item.rightText} from the ${(tagType || "topic").toLowerCase()} ${item.title.toLowerCase()}${masteryText}.`;
};

const CardContent = ({ items, tagType, handleClickCard }: Props) => {
	return (
		<Pressable onPress={handleClickCard} disabled={!handleClickCard}>
			<Card.Content
				style={{ paddingLeft: 4, paddingRight: 0, marginRight: -8 }}
			>
				{items.map((item) => {
					const tooltip = getToolTip(item, tagType);
					return (
						<MasteryListItem
							key={item.title}
							{...item}
							tooltip={tooltip}
							icon={item.icon}
						/>
					);
				})}
			</Card.Content>
		</Pressable>
	);
};

export default CardContent;
